export class Encoding {
    public static encodeHash(str: string) {
        if (!str) {
            return str;
        }
        return str.replaceAll("#", "%23");
    }
}
